import { CopyButton, StepBlock, VerifyStepShell } from './verifyShared';

export default function VerifyMetaStep(props) {
  const { domain, instructions } = props;
  const meta = (instructions && instructions.meta_tag) || {};
  const tag = meta.tag || '';

  return (
    <VerifyStepShell title={`Verify ${domain} with a meta tag`}
                     autoNote="Auto-checking every 10 seconds…" {...props}>
      {/* STEP 1 — copy the tag */}
      <StepBlock n={1} title="Copy this meta tag">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem',
                      border: '1px solid var(--b1)', borderRadius: 8, padding: '0.6rem 0.75rem',
                      background: 'var(--bg)' }}>
          <code style={{ fontFamily: 'ui-monospace, monospace', fontSize: '0.82rem',
                         color: 'var(--white)', flex: 1, wordBreak: 'break-all' }}>
            {tag}
          </code>
          <CopyButton value={tag} ariaLabel="Copy meta tag" />
        </div>
      </StepBlock>

      {/* STEP 2 — add to head */}
      <StepBlock n={2} title="Add it to your homepage <head> section">
        <p className="font-body" style={{ color: 'var(--ts)', fontSize: '0.84rem' }}>
          It must be on your homepage and inside <code>&lt;head&gt;…&lt;/head&gt;</code>.
        </p>
        <ul style={{ paddingLeft: '1.1rem', marginTop: '0.6rem', color: 'var(--tm)',
                     fontSize: '0.83rem', lineHeight: 1.7 }}>
          <li><strong>WordPress:</strong> “Insert Headers and Footers” plugin, or Appearance → Theme Editor → header.php</li>
          <li><strong>Webflow:</strong> Project Settings → Custom Code → Head Code</li>
          <li><strong>Wix:</strong> Settings → Custom Code → Add Custom Code → Head</li>
          <li><strong>Squarespace:</strong> Settings → Advanced → Code Injection → Header</li>
          <li><strong>Shopify:</strong> Online Store → Themes → Edit code → theme.liquid</li>
          <li><strong>Other:</strong> add inside the <code>&lt;head&gt;</code> of your homepage</li>
        </ul>
      </StepBlock>

      {/* STEP 3 — save and publish */}
      <StepBlock n={3} title="Save and publish">
        <p className="font-body" style={{ color: 'var(--tm)', fontSize: '0.84rem' }}>
          Most CMS platforms apply the change instantly. Some have caching that takes a minute or two to clear.
        </p>
      </StepBlock>
    </VerifyStepShell>
  );
}
